import { Heart, Sparkles } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative bg-gray-900 text-[#FFFAEB] pt-16 pb-8 px-4 border-t-4 border-gray-900"
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 mb-4">
            <Sparkles size={24} className="text-[#FFD166]" />
            <span className="font-display text-3xl">The Babysitting Club</span>
            <Sparkles size={24} className="text-[#FF6B9E]" />
          </div>
          <p className="font-hand text-2xl text-[#38E5B6] max-w-xl mx-auto">
            Natania · Grace · Alena · Neytra · Sadie · Elena
          </p>
          <p className="mt-6 text-sm font-semibold text-[#FFFAEB]/80 max-w-md mx-auto">
            A neighborhood babysitting club run by six 10–11 year old friends who think
            kids are the coolest.
          </p>

          <div className="mt-8 flex items-center justify-center gap-3">
            <a
              href="/poster"
              data-testid="footer-poster-link"
              className="inline-flex items-center gap-2 bg-[#FFD166] text-gray-900 font-display text-sm px-5 py-2 rounded-full border-2 border-[#FFFAEB]/40 hover:rotate-2 transition-transform"
            >
              🖨 Print our Poster
            </a>
          </div>

          {/* Color dots */}
          <div className="flex items-center justify-center gap-3 mt-6">
            {["#FF6B9E", "#4DB8FF", "#38E5B6", "#FFD166", "#FF8E72", "#FFEBF2"].map(
              (c, i) => (
                <span
                  key={c}
                  className="w-4 h-4 rounded-full border-2 border-[#FFFAEB]/30"
                  style={{ background: c, transform: `translateY(${i % 2 ? 4 : 0}px)` }}
                />
              )
            )}
          </div>

          <div className="mt-10 pt-6 border-t border-[#FFFAEB]/15 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#FFFAEB]/70">
            <p>© {new Date().getFullYear()} The Babysitting Club. Built with</p>
            <p className="inline-flex items-center gap-1.5">
              made with <Heart size={14} className="text-[#FF6B9E] fill-[#FF6B9E]" /> by six friends
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
